module.exports = __webpack_public_path__ + "static/5-b849960ff15bb73056bbab1830a512cc.png";